import { memo } from 'react'

const FieldOfViewButtonContainer = () => {
  return <div id='point-cloud-settings-button-container' />
}

export default memo(FieldOfViewButtonContainer)
